import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { LoaderSpinner } from '@/components/LoaderSpinner'

interface PageLoaderModalProps {
  open: boolean
  children?: React.ReactNode
}

const PageLoader: React.FC<PageLoaderModalProps> = ({ open, children }) => {
  return (
    <Dialog open={open} onClose={() => {}} className='relative z-30'>
      <DialogBackdrop
        transition
        className='fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in'
      />

      <div className='fixed inset-0 z-10 w-screen overflow-y-auto'>
        <div className='flex min-h-full items-end justify-center py-4 text-center sm:items-center sm:p-0'>
          <DialogPanel
            transition
            className='relative transform rounded-lg bg-white pt-5 pb-4 text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-md sm:py-6 data-closed:sm:translate-y-0 data-closed:sm:scale-95'
          >
            <div>
              <div className='p-4 sm:p-6'>
                <div className='flex flex-col gap-4 items-center justify-center'>
                  <div className='py-4'>
                    <LoaderSpinner />
                  </div>
                  {children &&
                    <DialogTitle as='h3' className='text-2xl text-center mt-3'>
                      {children}
                    </DialogTitle>
                  }
                </div>
                
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}

export { PageLoader }
